export default {
    title: 'Pets',
    subtitle: '{n} pet | {n} pets',
    newPet: 'New pet',
    search: 'Search pets',
    add: {
        placeholder: 'Add a pet…',
        save: 'Add',
    },
    species: {
        dog: 'Dog',
        cat: 'Cat',
        rabbit: 'Rabbit',
        bird: 'Bird',
        fish: 'Fish',
        other: 'Other',
    },
    age: {
        years: '{n} year | {n} years',
        months: '{n} mo.',
        weeks: '{n} wk.',
    },
    fields: {
        name: 'Name',
        namePlaceholder: 'Name',
        species: 'Species',
        breed: 'Breed',
        breedPlaceholder: 'e.g. dachshund, tabby',
        birthDate: 'Date of birth',
    },
    weight: {
        title: 'Weight',
        add: 'Add measurement',
        kg: 'Weight in kilograms',
        kgPlaceholder: 'e.g. 12.4',
        date: 'Day of measurement',
        save: 'Save',
        cancel: 'Cancel',
        remove: 'Delete measurement',
        empty: 'No measurements yet. One a day — another one on the same day replaces it.',
        chartAria: 'Weight chart: {n} measurements',
        all: 'All ({n})',
        less: 'Less',
    },
    notes: {
        title: 'Note',
        placeholder: 'Food, vet with phone number, allergies, microchip number…',
    },
    empty: {
        title: 'No pets here yet',
        text: 'Add your pet — vaccinations, deworming and vet visits will remind themselves.',
        noMatchTitle: 'Nothing matches',
        noMatchText: 'Change the phrase or clear the search field.',
    },
    pick: {
        title: 'Pick a pet',
        text: 'Or add a new one in the field above the list.',
    },
    toolbar: {
        back: 'Back to the list',
        remove: 'Delete pet',
        saving: 'Saving…',
        saveError: 'Couldn’t save — we’ll try again with the next change',
    },
    toast: {
        removed: 'Deleted: {name}',
    },
    help: {
        add: {
            title: 'Add a pet',
            text: 'Type a name, pick the species and press Enter. Fill in the rest on the right.',
            more: 'The assistant adds a pet too when you say e.g. “Rex weighs 12 kg” or “I had Rex vaccinated”.',
        },
        list: {
            title: 'Your pets',
            text: 'Those with the nearest care on top. The badge says what and when — “in 5 days · deworming”.',
            more: 'An orange badge means the date has passed.',
        },
        cares: {
            title: 'Care',
            text: 'Vaccination, deworming, ticks… Set how many months apart, and “Done” saves the day and moves the next date.',
            more: 'You can also set the date by hand (e.g. when the vet says come back in two weeks) — it holds until the next “Done”. A week before, the care shows up in “Right now” and in the Planner.',
        },
        weight: {
            title: 'Weight',
            text: 'Add measurements and the chart shows how the weight changes.',
            more: 'One measurement a day — a second one on the same day replaces the first.',
        },
    },
    tour: {
        welcome: {
            title: 'Welcome to Pets',
            description: 'A place for your pets: vaccinations, deworming, vet visits and weight. The dates remind themselves.',
        },
        pet: {
            title: 'Pet',
            description: 'On the right: name, species, breed and date of birth, care with the “Done” button, weight with a chart, and a note. Everything saves itself.',
        },
        end: {
            title: 'That’s all',
            description: 'The guide is always under “Help” — First steps are there too. And “What’s this?” next to a section explains it without the guide.',
        },
    },
    firstSteps: {
        pet: {
            title: 'First pet',
            action: 'Add a pet',
            what: 'Type a name in “Add a pet…”, pick the species and press Enter.',
            why: 'Care and weight belong to the pet.',
        },
        care: {
            title: 'Care',
            action: 'Add care',
            what: 'Open the pet and add e.g. a vaccination or deworming — from the suggestions or under your own name.',
            why: 'The date will remind you in “Right now” and in the Planner.',
        },
        done: {
            title: 'Done',
            action: 'Save it as done',
            what: 'Click “Done” next to a care item — with the day, cost and a note.',
            why: 'The next date counts from that day.',
        },
        weight: {
            title: 'Weight',
            action: 'Add a measurement',
            what: 'Add the first weight measurement.',
            why: 'With more of them, the chart shows how it changes.',
        },
    },
};
